import {IOwnership} from "@leap4/general-common";

const date = new Date(Date.now())

export const defaultOwnershipObj: IOwnership = {
    publisherTag: null,
    supplyTag: null,
    timestamp: new Date(date.setDate(date.getDate() - 1)),
    percent: 0,
    ownershipValue: 0,
}